/* BLC v7 - live artwork preview behaviour.
   Reads the artwork the customer picked in the product form and draws
   it inside the shape template's print area. Drag to move, slider to
   resize. Placement is written to a hidden line-item property so the
   order in Shopify admin records what the customer intended.

   Strings arrive on data-* attributes so this file stays translatable
   without being Liquid. */
(function () {
  var MAX_BYTES = 20 * 1024 * 1024;

  function initOne(root) {
    var wrap = root.querySelector('[data-blc7v]');
    var file = root.querySelector('[data-blc7-file]');
    if (!wrap || !file) return;

    var tpl      = wrap.querySelector('[data-blc7v-tpl]');
    var art      = wrap.querySelector('[data-blc7v-art]');
    var printBox = wrap.querySelector('[data-blc7v-print]');
    var range    = wrap.querySelector('[data-blc7v-range]');
    var reset    = wrap.querySelector('[data-blc7v-reset]');
    var controls = wrap.querySelector('[data-blc7v-controls]');
    var pdfNote  = wrap.querySelector('[data-blc7v-pdf]');
    var placeInp = wrap.querySelector('[data-blc7v-placement]');
    var tabs     = [].slice.call(wrap.querySelectorAll('[data-blc7v-tab]'));
    var panes    = [].slice.call(wrap.querySelectorAll('[data-blc7v-pane]'));

    var state = { tx: 0, ty: 0, s: 1 };

    function apply() {
      art.style.setProperty('--tx', state.tx + '%');
      art.style.setProperty('--ty', state.ty + '%');
      art.style.setProperty('--s', state.s);
      if (placeInp) {
        placeInp.value = 'x ' + Math.round(state.tx) + '% / y ' + Math.round(state.ty) +
                         '% / ' + Math.round(state.s * 100) + '%';
      }
    }

    function resetPlacement() {
      state.tx = 0; state.ty = 0; state.s = 1;
      if (range) range.value = 100;
      apply();
    }

    function showTab(name) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-blc7v-tab') === name ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        p.setAttribute('data-active', p.getAttribute('data-blc7v-pane') === name ? 'true' : 'false');
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { showTab(t.getAttribute('data-blc7v-tab')); });
    });

    /* ---- artwork in ---- */
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];

      if (!f || f.size > MAX_BYTES) {
        tpl.setAttribute('data-has-art', 'false');
        if (controls) controls.setAttribute('data-enabled', 'false');
        if (pdfNote) pdfNote.setAttribute('data-show', 'false');
        art.removeAttribute('src');
        if (placeInp) placeInp.value = '';
        showTab('photo');
        return;
      }

      var isPdf = /pdf$/i.test(f.type) || /\.pdf$/i.test(f.name);
      if (pdfNote) pdfNote.setAttribute('data-show', isPdf ? 'true' : 'false');

      if (isPdf) {
        /* Browsers cannot rasterise a PDF in an <img>, so there is no
           honest preview to show. Say so instead of faking one. */
        tpl.setAttribute('data-has-art', 'false');
        if (controls) controls.setAttribute('data-enabled', 'false');
        art.removeAttribute('src');
        if (placeInp) placeInp.value = '';
        showTab('preview');
        return;
      }

      var reader = new FileReader();
      reader.onload = function (e) {
        art.src = e.target.result;
        tpl.setAttribute('data-has-art', 'true');
        if (controls) controls.setAttribute('data-enabled', 'true');
        resetPlacement();
        showTab('preview');
      };
      reader.readAsDataURL(f);
    });

    /* ---- resize ---- */
    if (range) {
      range.addEventListener('input', function () {
        state.s = parseInt(range.value, 10) / 100;
        apply();
      });
    }
    if (reset) reset.addEventListener('click', resetPlacement);

    /* ---- drag to move, in % of the print box so it scales with the
       viewport instead of drifting on mobile ---- */
    var dragging = false, startX = 0, startY = 0, baseX = 0, baseY = 0, boxW = 1, boxH = 1;

    printBox.addEventListener('pointerdown', function (ev) {
      if (tpl.getAttribute('data-has-art') !== 'true') return;
      var r = printBox.getBoundingClientRect();
      boxW = r.width || 1; boxH = r.height || 1;
      dragging = true;
      startX = ev.clientX; startY = ev.clientY;
      baseX = state.tx; baseY = state.ty;
      printBox.setPointerCapture(ev.pointerId);
    });

    printBox.addEventListener('pointermove', function (ev) {
      if (!dragging) return;
      state.tx = baseX + ((ev.clientX - startX) / boxW) * 100;
      state.ty = baseY + ((ev.clientY - startY) / boxH) * 100;
      /* keep it near the print area rather than letting it fly off */
      state.tx = Math.max(-60, Math.min(60, state.tx));
      state.ty = Math.max(-60, Math.min(60, state.ty));
      apply();
    });

    function endDrag(ev) {
      if (!dragging) return;
      dragging = false;
      try { printBox.releasePointerCapture(ev.pointerId); } catch (e) {}
    }
    printBox.addEventListener('pointerup', endDrag);
    printBox.addEventListener('pointercancel', endDrag);

    apply();
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-blc7-root]')).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor re-renders sections without a page load. */
  document.addEventListener('shopify:section:load', boot);
})();
